"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.snapshot2pretty = exports.getMonthOfSnapshot = exports.getYearOfSnapshot = exports.inferSchoolYear = exports.MONTH_OF_NEW_SCHOOL_YEAR = void 0;
exports.MONTH_OF_NEW_SCHOOL_YEAR = 7;
const inferSchoolYear = (snapshot) => {
    const isNewYear = exports.getMonthOfSnapshot(snapshot) >= exports.MONTH_OF_NEW_SCHOOL_YEAR;
    const snapshotYear = exports.getYearOfSnapshot(snapshot);
    return isNewYear ? `${snapshotYear}-${snapshotYear + 1}` : `${snapshotYear - 1}-${snapshotYear}`;
};
exports.inferSchoolYear = inferSchoolYear;
const getYearOfSnapshot = (snapshot) => Number(snapshot.split("-")[0]);
exports.getYearOfSnapshot = getYearOfSnapshot;
const getMonthOfSnapshot = (snapshot) => (Number(snapshot.split("-")[1]) - 1);
exports.getMonthOfSnapshot = getMonthOfSnapshot;
const snapshot2pretty = (snapshot) => snapshot.replace(/[-_]/g, " ");
exports.snapshot2pretty = snapshot2pretty;
//# sourceMappingURL=Snapshot.js.map